

















import { computed, defineComponent, PropType, toRefs } from '@nuxtjs/composition-api'

const dSelectButton = defineComponent({
  name: 'DSelectButton',
  props: {
    label: {
      type: String as PropType<string>,
      default: ''
    },
    width: {
      type: String as PropType<string>,
      default: 'auto'
    },
    isActive: {
      type: Boolean as PropType<boolean>,
      default: true
    },
    isOpen: {
      type: Boolean as PropType<boolean>,
      default: false
    }
  },

  setup(props) {
    const { width } = toRefs(props)
    const computedStyle = computed(() => {
      return {
        width: width.value
      }
    })

    return { computedStyle }
  }
})
export default dSelectButton
